import { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Input, ErrorText } from '@utilities';
import { parseNumber } from '../../utilities/helpers';
import { VOLUME_INPUT_TYPES } from '../../utilities/constants';
import styles from './_index.module.scss';

const VolumeInputs = ({ onChangeValues, purchaseType, selectedAnswer }) => {
  const purchaseTypeText = VOLUME_INPUT_TYPES[purchaseType] || VOLUME_INPUT_TYPES.purchase_volume;

  const [upper, setUpper] = useState(selectedAnswer?.values?.[1] ?? '');
  const [lower, setLower] = useState(selectedAnswer?.values?.[0] ?? '');

  useEffect(() => {
    setUpper(selectedAnswer?.values?.[1] ?? '');
    setLower(selectedAnswer?.values?.[0] ?? '');
  }, [selectedAnswer?.attributeId]);

  const upperValue = parseNumber(upper);
  const lowerValue = parseNumber(lower);
  const validPair = lowerValue === undefined || upperValue === undefined || lowerValue < upperValue;

  const validationErrorMessage =
    lowerValue < 0 || upperValue < 0
      ? 'Values cannot be negative'
      : validPair
        ? ''
        : purchaseTypeText?.errorText || 'Invalid input values';

  const handleChange = (nextLower, nextUpper) => {
    onChangeValues([parseNumber(nextLower), parseNumber(nextUpper)]);
  };

  return (
    <div className={styles['volume-inputs-config-block']}>
      <div>
        <h4>{purchaseTypeText?.higherTitle}</h4>
        <div className={styles['volume-inputs-config-block-input']}>
          {purchaseTypeText?.higherHint ? <p>{purchaseTypeText.higherHint}</p> : null}
          <Input
            className={classNames({
              [styles['volume-inputs-error']]: upperValue < 0 || !validPair,
            })}
            onChange={(val) => {
              setUpper(val);
              handleChange(lower, val);
            }}
            placeholder="--"
            type="number"
            value={upper}
          />
        </div>
      </div>

      <div>
        <h4>{purchaseTypeText?.lowerTitle}</h4>
        <div className={styles['volume-inputs-config-block-input']}>
          {purchaseTypeText?.lowerHint ? <p>{purchaseTypeText.lowerHint}</p> : null}
          <Input
            className={classNames({
              [styles['volume-inputs-error']]: lowerValue < 0 || !validPair,
            })}
            onChange={(val) => {
              setLower(val);
              handleChange(val, upper);
            }}
            placeholder="--"
            type="number"
            value={lower}
          />
        </div>
      </div>
      {purchaseTypeText?.helperText ? (
        <div className={styles['volume-inputs-config-block-helper']}>
          <span>{purchaseTypeText?.helperText}</span>
        </div>
      ) : null}
      {validationErrorMessage && <ErrorText text={validationErrorMessage} />}
    </div>
  );
};

VolumeInputs.propTypes = {
  onChangeValues: PropTypes.func.isRequired,
  purchaseType: PropTypes.oneOf(['purchase_volume', 'purchase_shift']),
  selectedAnswer: PropTypes.shape({
    attributeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  }).isRequired,
};

export default VolumeInputs;
